const getClientSettingTypes = {
  GET_CLIENT_SETTING_REQUEST: "GET_CLIENT_SETTING_REQUEST",
  GET_CLIENT_SETTING_SUCCEEDED: "GET_CLIENT_SETTING_SUCCEEDED",
  GET_CLIENT_SETTING_FAILED: "GET_CLIENT_SETTING_FAILED",
  GET_CLIENT_SETTING_END: "GET_CLIENT_SETTING_END",
};

const galleryVotingTypes = {
  GALLERY_VOTING_REQUEST: "GALLERY_VOTING_REQUEST",
  GALLERY_VOTING_SUCCEEDED: "GALLERY_VOTING_SUCCEEDED",
  GALLERY_VOTING_FAILED: "GALLERY_VOTING_FAILED",
  GALLERY_VOTING_END: "GALLERY_VOTING_END",
};

const trackContentViewTypes = {
  TRACK_CONTENT_VIEW_REQUEST: "TRACK_CONTENT_VIEW_REQUEST",
  TRACK_CONTENT_VIEW_SUCCEEDED: "TRACK_CONTENT_VIEW_SUCCEEDED",
  TRACK_CONTENT_VIEW_FAILED: "TRACK_CONTENT_VIEW_FAILED",
  TRACK_CONTENT_VIEW_END: "TRACK_CONTENT_VIEW_END",
};

const fetchGalleryTypes = {
  FETCH_GALLERY_REQUEST: "FETCH_GALLERY_REQUEST",
  FETCH_GALLERY_SUCCEEDED: "FETCH_GALLERY_SUCCEEDED",
  FETCH_GALLERY_FAILED: "FETCH_GALLERY_FAILED",
  FETCH_GALLERY_END: "FETCH_GALLERY_END",
};

const storeDataTypes = {
  STORE_DATA_REQUEST: "STORE_DATA_REQUEST",
};

export {
  getClientSettingTypes,
  galleryVotingTypes,
  trackContentViewTypes,
  storeDataTypes,
  fetchGalleryTypes,
};
